import {
  ADMIN_ORDER_DETAILS,
  AdminInput,
  Button,
  Modal,
  PropsModal,
} from '@vgrubs/components';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export const SearchOrderByIdModal = ({
  modalIsOpen,
  closeModal,
}: PropsModal & {
  modalIsOpen: boolean;
}) => {
  const [id, setId] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (!id) return;
    navigate(`${ADMIN_ORDER_DETAILS.replace(':id', id)}`);
    closeModal?.();
    setId(null);
  };

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      zIndex={110}
    >
      <AdminInput
        label="Search By Order ID"
        type="text"
        value={id ?? ''}
        onChange={(e) => setId(e.target.value)}
        $textCenter
        placeholder="Enter Here"
      />

      <Button $mt="24" $w="100%" $selected onClick={handleSearch}>
        Search
      </Button>
    </Modal>
  );
};
